import r, { createContext as n, useContext as i } from "react";
var e = n(function () {});
function l() {
  return i(e);
}
function u(_ref) {
  var o = _ref.value,
    t = _ref.children;
  return r.createElement(e.Provider, {
    value: o
  }, t);
}
export { u as CloseProvider, l as useClose };